import { useApplicationContext } from '@/context/v1/Application/context';
import { useGetUsers } from '@/hooks/useGetUsers';

export function useResponsible() {
	const { organization, company } = useApplicationContext();

	const { isLoading: isLoadingUsers, data: users } = useGetUsers({
		organization_id: organization.id!,
		company_id: company.id!
	});

	const usersOptions = users?.map((user) => ({ label: user.name, value: user.id }));

	return { usersOptions, isLoading: isLoadingUsers };
}
